import { render, staticRenderFns } from "./contentPage.vue?vue&type=template&id=14fa3358&scoped=true&"
import script from "./contentPage.vue?vue&type=script&lang=js&"
export * from "./contentPage.vue?vue&type=script&lang=js&"
import style0 from "./contentPage.vue?vue&type=style&index=0&id=14fa3358&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fa3358",
  null
  
)

export default component.exports